import { makeAutoObservable, runInAction, toJS } from 'mobx'

import { http } from '@/utils'
import { message } from 'antd';

class DeviceStore {
    //数据列表初始化
    dataList = [];
    //总条数
    total = '';
    //条数
    limit = 10;
    //当前页
    page = 1;

    //弹框显示
    isAshow = false;
    //弹框状态初始化
    isActive = false
    title = ''

    //搜索规则
    filter = ''
    op = ''
    //下拉数据存放
    selectdata = []

    Datashow = []
    //可展示的类型
    type = ["button", "label", "time", "tab",]
    //编号code
    DevCode = ''
    //查看
    seevalue = {}
    //展示数据的计量数
    Num = 0
    constructor() {
        makeAutoObservable(this)
    }
    //新增下拉数据
    // newselect = async () => {
    //     const res = await http.get(`/coopapi/device/getGreenhouseList`)
    //     if (res.status === 200) {
    //         res.data.Data.map((item, index) => {
    //             this.selectdata = this.selectdata.concat({ value: `${item.GreenHouseId + ',' + item.GreenHouseName}`, label: item.GreenHouseName })
    //         })
    //     }
    // }
    getDataList = async () => {
        if (this.filter && this.op) {
            const res = await http.get(`/coopapi/device/devlist?page=${this.page}&limit=${this.limit}`, {
                params: {
                    filter: this.filter,
                    op: this.op
                }
            })
            runInAction(() => {
                this.dataList = JSON.parse(JSON.stringify(res.data.rows))
                this.total = res.data.total
            })
        } else {
            const res = await http.get(`/coopapi/device/devlist?page=${this.page}&limit=${this.limit}`)
            if (res.status === 200) {
                runInAction(() => {
                    this.dataList = JSON.parse(JSON.stringify(res.data.rows))
                    this.total = res.data.total
                })
            }
        }
    }
    //新增
    getAddDevice = async (values) => {
        const res = await http.post(`/coopapi/device/addDev`, values)
        if (res.data.code === 200) {
            runInAction(() => {
                this.getDataList()
                runInAction(() => {
                    this.isAshow = false
                })
            })
        } else {
            message.error(res.data.msg)
        }
    }
    //删除
    getDeleteButtom = async (id) => {
        const res = await http.post(`/coopapi/device/delete`, { id: id })
        if (res.data.code === 200) {
            runInAction(() => {
                this.getDataList()
            })
        }
    }
    //设置跳页
    setPage = async (code) => {
        const res = await http.get(`/coopapi/device/getdevstatus?devCode=${code}`)
        let Numa = 0
        if (res.status === 200) {
            runInAction(() => {
                this.Datashow = res.data.Data
            })
        }
        if (this.Datashow) {
            this.Datashow.map((item, index) => {
                if (!item.NotShow && this.type.indexOf(item.DisplayType) > -1) {
                    Numa = this.Num + 1
                }

            })
        }
        if (Numa === 0) {
            message.error('暂无数据')
        }

    }

    //修改
    getSubmit = async (values) => {
        const res = await http.post(`/coopapi/device/setdevproperty`, values)
        if (res.data.Code === 0) {
            this.setPage(this.DevCode)
            message.success(res.data.Message)
        }
    }
}

export { DeviceStore }